import { useId } from 'react';

/** Local, deterministic SVG texture; no image requests or animated effects. */
export function HeroBackdrop() {
  const id = useId();
  return (
    <svg
      className="snap-landing__texture"
      viewBox="0 0 1380 652"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <filter id={`${id}-cloud`}>
          <feTurbulence
            type="fractalNoise"
            baseFrequency=".008 .014"
            numOctaves="4"
            seed="17"
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <filter id={`${id}-grain`}>
          <feTurbulence
            type="fractalNoise"
            baseFrequency=".55"
            numOctaves="3"
            seed="8"
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
      </defs>
      <rect
        width="100%"
        height="100%"
        filter={`url(#${id}-cloud)`}
        opacity=".1"
      />
      <rect
        width="100%"
        height="100%"
        filter={`url(#${id}-grain)`}
        opacity=".06"
      />
      {Array.from({ length: 160 }, (_, i) => (
        <circle
          key={i}
          cx={(i * 187.73 + 31) % 1380}
          cy={(i * i * 31.17 + 19) % 652}
          r={0.5 + (i % 4) * 0.45}
          fill="#ffe2d8"
          opacity={0.07 + (i % 5) * 0.025}
        />
      ))}
    </svg>
  );
}
